(function () {
  function initCustomFlowSection(root = document) {
    root.querySelectorAll('[data-custom-flow-section]').forEach((section) => {
      // 防止 section 被重複初始化（Shopify theme editor 熱重載時會再次觸發）
      if (section.dataset.customFlowInit === 'true') return

      // ─── DOM 參考快取（只查詢一次，避免重複 querySelector）───────────────────
      const swiperEl  = section.querySelector('[data-flow-swiper]')
      const collapseEl = section.querySelector('.custom-flow-section__collapse')

      // NodeList 轉 Array，避免後續每次呼叫都需要 Array.from()
      const accordionItems    = Array.from(section.querySelectorAll('[data-flow-accordion-item]'))
      const accordionTriggers = Array.from(section.querySelectorAll('[data-flow-accordion-trigger]'))

      if (!swiperEl || !accordionItems.length || !accordionTriggers.length) return

      // 將每個 accordion item 的 trigger / panel 預先 cache 成物件陣列，
      // 避免在 updateAccordionState（hot path）裡重複呼叫 querySelector
      const accordionCache = accordionItems.map((item) => ({
        item,
        trigger: item.querySelector('[data-flow-accordion-trigger]'),
        panel:   item.querySelector('[data-flow-accordion-panel]'),
      }))

      // 預先 cache 所有影片元素，避免每次 slide 切換都 querySelectorAll
      const videoWraps = Array.from(section.querySelectorAll('[data-flow-video-wrap]'))
      const videos     = videoWraps.map((wrap) => wrap.querySelector('video'))

      // ─── 影片 UI 輔助函式 ────────────────────────────────────────────────────

      // 同步播放/靜音按鈕的 icon 狀態，反映影片實際狀態
      const updateVideoUI = (videoWrap, video) => {
        videoWrap.classList.toggle('is-paused', video.paused)
        videoWrap.classList.toggle('is-muted',  video.muted)
      }

      // 暫停並重置所有影片（切換 slide 前呼叫，確保非當前 slide 的影片停止）
      const pauseAllVideos = () => {
        videos.forEach((video) => {
          if (!video) return
          video.pause()
          video.currentTime = 0
        })
      }

      // 播放當前 active slide 的影片（如果有的話）
      // 永遠從 DOM 查詢 .swiper-slide-active，而非用 index 查 swiper.slides[]：
      // loop:true 模式下 Swiper 會插入 clone slides，導致 slides[] 的陣列索引偏移。
      const playActiveSlideVideoIfAny = () => {
        const activeSlide    = swiperEl.querySelector('.swiper-slide-active')
        const activeVideoWrap = activeSlide?.querySelector('[data-flow-video-wrap]')
        const activeVideo    = activeVideoWrap?.querySelector('video')

        if (!activeVideoWrap || !activeVideo) return

        activeVideo.muted = true
        activeVideo.currentTime = 0
        const playPromise = activeVideo.play()
        // play() 回傳 Promise；catch 空函式以抑制「play interrupted」DOMException
        // （在 pause() 於 play() resolve 前被呼叫時會觸發，屬預期行為）
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {})
        }
        updateVideoUI(activeVideoWrap, activeVideo)
      }

      // ─── 影片控制初始化（每個影片只執行一次）────────────────────────────────
      videoWraps.forEach((videoWrap, i) => {
        const video      = videos[i]
        const playButton = videoWrap.querySelector('[data-flow-video-play]')
        const muteButton = videoWrap.querySelector('[data-flow-video-mute]')

        if (!video || !playButton || !muteButton) return

        // 同時設定 JS property 和 HTML attribute，確保最大跨瀏覽器相容性
        // （部分瀏覽器只在 parse 階段讀取 attribute，部分只讀 property）
        video.autoplay     = true
        video.defaultMuted = true
        video.muted        = true
        video.loop         = true
        video.volume       = 0
        video.playsInline  = true
        video.setAttribute('autoplay',    '')
        video.setAttribute('muted',       '')
        video.setAttribute('loop',        '')
        video.setAttribute('playsinline', '')

        const syncState = () => updateVideoUI(videoWrap, video)

        // 手動播放/暫停切換
        playButton.addEventListener('click', (event) => {
          event.preventDefault()
          event.stopPropagation()
          if (video.paused) {
            const playPromise = video.play()
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {})
            }
          } else {
            video.pause()
          }
          syncState()
        })

        // 靜音/取消靜音切換
        muteButton.addEventListener('click', (event) => {
          event.preventDefault()
          event.stopPropagation()
          video.muted = !video.muted
          syncState()
        })

        // 監聽影片狀態變化，保持按鈕 icon 同步
        video.addEventListener('play',         syncState)
        video.addEventListener('pause',        syncState)
        video.addEventListener('volumechange', syncState)

        // 手動迴圈保險：部分低功耗模式瀏覽器在靜音影片上不會自動重播，
        // 以 ended 事件手動重置並 replay
        video.addEventListener('ended', () => {
          video.currentTime = 0
          const loopPlayPromise = video.play()
          if (loopPlayPromise && typeof loopPlayPromise.catch === 'function') {
            loopPlayPromise.catch(() => {})
          }
        })

        syncState()
      })

      // ─── Swiper 初始化 ───────────────────────────────────────────────────────
      const swiperConfig = {
        slidesPerView: 1,
        spaceBetween:  0,
        // 注意：loop:true 會在首尾插入 clone slides
        // → 必須用 swiper.realIndex（非 activeIndex）取得邏輯 index
        // → 必須用 slideToLoop()（非 slideTo()）以 realIndex 導航
        loop: true,
        navigation: {
          nextEl: section.querySelector('[data-flow-next]'),
          prevEl: section.querySelector('[data-flow-prev]'),
        },
      }

      const swiper =
        typeof window.createCustomSwiper === 'function'
          ? window.createCustomSwiper(swiperEl, swiperConfig)
          : new Swiper(swiperEl, swiperConfig)

      // ─── Accordion 狀態管理 ──────────────────────────────────────────────────

      // 更新所有 accordion item 的開/關狀態。
      // 傳入 index = -1 可全部關閉。
      // 使用預先 cache 的 accordionCache 避免在迴圈內 querySelector。
      const updateAccordionState = (index) => {
        accordionCache.forEach(({ item, trigger, panel }, itemIndex) => {
          const isActive = itemIndex === index
          item.classList.toggle('is-open', isActive)
          if (trigger) trigger.setAttribute('aria-expanded', String(isActive))
          if (panel)   panel.hidden = !isActive
        })
      }

      // 鎖定 collapse 欄的 min-height 為最高 accordion item 的高度，
      // 防止 media 欄隨 panel 開關而跳動。僅在桌面版（≥1024px）啟用。
      const syncCollapseMinHeight = () => {
        if (!collapseEl) return

        if (!window.matchMedia('(min-width: 1024px)').matches) {
          collapseEl.style.minHeight = ''
          return
        }

        // 先記住當前開啟的 item，量完後恢復
        const previousActiveIndex = accordionItems.findIndex((item) => item.classList.contains('is-open'))
        let maxHeight = 0

        // 依序展開每個 item 並讀取高度（每次 offsetHeight 會觸發 forced reflow，
        // 此處無可避免，因為需要實際渲染高度；debounce resize 可降低觸發頻率）
        accordionItems.forEach((_, itemIndex) => {
          updateAccordionState(itemIndex)
          maxHeight = Math.max(maxHeight, collapseEl.offsetHeight)
        })

        // 恢復先前的開啟狀態，再套用 min-height
        updateAccordionState(previousActiveIndex)
        collapseEl.style.minHeight = maxHeight > 0 ? `${Math.ceil(maxHeight)}px` : ''
      }

      // resize 加 debounce（150ms）：syncCollapseMinHeight 內有多次 offsetHeight 讀取，
      // 若在每個 resize pixel 都觸發會造成大量 forced reflow，影響捲動流暢度
      let resizeTimer = null
      const handleResize = () => {
        clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => {
          syncCollapseMinHeight()
          swiper.update()
          swiper.slideTo(swiper.activeIndex, 0)
        }, 150)
      }

      window.addEventListener('resize', handleResize, { passive: true })

      // ─── 媒體同步排程 ────────────────────────────────────────────────────────

      // 儲存待執行的 rAF ID，用於取消過時的排程
      let mediaSyncRafId = null

      // 當前動畫預計停靠的 realIndex（-1 = 無待命目標）
      // 用於過濾 loop 模式下 clone slide 觸發的中間 slideChange 事件
      let pendingSlideIndex = -1

      // 在下一個 paint frame 執行 pause all + play active。
      // 若前一個排程尚未執行，先 cancel，確保只有最後一次切換生效。
      const queueSyncActiveMedia = () => {
        if (mediaSyncRafId !== null) {
          cancelAnimationFrame(mediaSyncRafId)
        }
        mediaSyncRafId = requestAnimationFrame(() => {
          mediaSyncRafId = null
          pauseAllVideos()
          playActiveSlideVideoIfAny()
        })
      }

      // 設定 accordion 展開狀態，並視需要同步驅動 Swiper。
      // syncSwiper = true  → 由使用者互動觸發（click / hover）
      // syncSwiper = false → 由 Swiper slideChange 觸發，accordion 跟隨
      const setActiveAccordion = (index, syncSwiper = true) => {
        updateAccordionState(index)

        if (syncSwiper) {
          if (swiper.realIndex !== index) {
            // 記錄目標 index，讓 slideChange handler 過濾掉中間過渡的 clone slides
            pendingSlideIndex = index
            swiper.slideToLoop(index) // 用 slideToLoop 而非 slideTo，接受 realIndex
          } else {
            // 已在正確 slide，直接同步媒體
            pendingSlideIndex = -1
            queueSyncActiveMedia()
          }
        } else {
          queueSyncActiveMedia()
        }
      }

      // ─── 事件綁定 ────────────────────────────────────────────────────────────

      // 點擊展開/收合 accordion item
      accordionTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const index = Number(trigger.dataset.flowIndex)
          if (Number.isNaN(index)) return

          // 點擊已展開的 item → 全部收合（index -1）
          const activeItem = accordionItems[index]
          if (activeItem?.classList.contains('is-open')) {
            updateAccordionState(-1)
            return
          }

          setActiveAccordion(index, true)
        })
      })

      // Hover 展開，加 80ms debounce：
      // 滑鼠快速掃過多個 item 時，只有停留超過 80ms 的 item 才會觸發 slideTo，
      // 避免多個動畫競爭導致 Swiper 卡住。
      let mouseEnterTimer = null
      accordionItems.forEach((item, itemIndex) => {
        item.addEventListener('mouseenter', () => {
          clearTimeout(mouseEnterTimer)
          mouseEnterTimer = setTimeout(() => {
            setActiveAccordion(itemIndex, true)
          }, 80)
        })
      })

      // Swiper 完成 slide 切換後，同步 accordion 狀態。
      // loop:true 動畫過程中每經過一個 clone slide 都會觸發 slideChange，
      // 透過 pendingSlideIndex 過濾掉中間過渡，只在抵達目標時更新 accordion。
      swiper.on('slideChange', () => {
        if (pendingSlideIndex !== -1 && swiper.realIndex !== pendingSlideIndex) return
        pendingSlideIndex = -1
        setActiveAccordion(swiper.realIndex, false)
      })

      // ─── 初始化 ──────────────────────────────────────────────────────────────
      setActiveAccordion(0, false)
      syncCollapseMinHeight()
      queueSyncActiveMedia()
      section.dataset.customFlowInit = 'true'

      // 字型載入後重新量測（字型 swap 可能改變文字高度，影響 min-height 計算）
      if (document.fonts && typeof document.fonts.ready?.then === 'function') {
        document.fonts.ready.then(syncCollapseMinHeight)
      }

      // Shopify theme editor 卸載 section 時清除 resize 監聽，防止記憶體洩漏
      section.addEventListener('shopify:section:unload', () => {
        window.removeEventListener('resize', handleResize)
      }, { once: true })
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCustomFlowSection()
  })

  document.addEventListener('shopify:section:load', (event) => {
    initCustomFlowSection(event.target)
  })
})()
